import i18next from 'i18next';

import {
    getValidLanguageCode,
    localStorageService,
} from '../../shared';

export function useManageLanguage(): {
    onLanguageChange: (lang: string, shouldPersist?: boolean) => void;
} {
    function onLanguageChange(lang: string, shouldPersist: boolean = true) {
        const validLanguage = getValidLanguageCode(lang);

        if (shouldPersist) {
            localStorageService.setItem('LANGUAGE', validLanguage);
        }

        i18next.changeLanguage(validLanguage);
    }

    return { onLanguageChange };
}
